import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const classes = 'inline-flex items-center gap-1.5 rounded-sm border border-border bg-background/80 px-3 py-2 text-xs font-semibold text-foreground shadow-sm transition-colors hover:bg-secondary';

export const HierarchyBackButton = ({ to, onClick, label = 'Back', testId }) => {
  const content = <><ArrowLeft className="h-3.5 w-3.5" /> {label}</>;
  if (to) {
    return <Link to={to} className={classes} data-testid={testId}>{content}</Link>;
  }
  return (
    <button type="button" onClick={onClick} className={classes} data-testid={testId}>
      {content}
    </button>
  );
};